import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { clinicalSessionApi } from '../../services/clinicalSessionApi';
import { clinicalSessionKeys } from './useGetClinicalSession';

export function useDeleteClinicalSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => clinicalSessionApi.deleteClinicalSession(id),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully deleted clinical session');
        queryClient.invalidateQueries({ queryKey: clinicalSessionKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to delete clinical session'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to delete clinical session'}`);
    },
  });
}
